import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PracticeDuration = lazyWithPreload(
  () => import('./PracticeDuration'),
)
export const LikeChatPracticeDuration = lazyWithPreload(
  () => import('./LikeChatPracticeDuration'),
)
export const PracticeDurationVariant2 = lazyWithPreload(
  () => import('./PracticeDurationVariant2'),
)
